import { ConstantItems, getDefaultConfig } from "@constants/shared";
import * as _ from 'lodash'




export class ComplianceRepo {

  /** @ngInject */
  constructor(private $http: angular.IHttpService, private config: ConstantItems) { }

  getCashTransactions = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/cash/transactions`, config);

  }

  getCashTransactionHistory = (transactionId) => {
    return this.$http.get(`${this.config.complianceUrl}/cash/transactions/${transactionId}/history`);
  }

  getPerformanceParameters =  (fromDate, toDate, currency) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate,
      currency : currency
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/performance`, config);

  }

  getPerformanceParametersHistory =  (performanceParameterId, portfolioId, performanceDate) => {
    let queryParams = {
      portfolioId : portfolioId,
      performanceDate : performanceDate,
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/performance/parameters/${performanceParameterId}/history`, config);

  }

  getTradingRestrictions = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/trades/restrictions`, config);
  }

  getTradingRestrictionHistory = (restrictionId) => {
    return this.$http.get(`${this.config.complianceUrl}/trades/restrictions/${restrictionId}/history`);
  }

  getFeeExclusions = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/fees/exclusions`, config);
  }

  getFeeExclusionHistory = (exclusionId) => {
    return this.$http.get(`${this.config.complianceUrl}/fees/exclusions/${exclusionId}/history`);
  }


  getClientFees = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/fees/clients`, config);
  }

  getClientFeeHistory = (clientFeeId) => {
    return this.$http.get(`${this.config.complianceUrl}/fees/clients/${clientFeeId}/history`);
  }

  getCModels = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/cmodels`, config);
  }

  getCustodianReports = (fromDate, toDate) => {
    let queryParams = {
      fromDate : fromDate,
      toDate : toDate
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.complianceUrl}/custodian/reports`, config);
  }

}



// WEBPACK FOOTER //
// ./src/services/compliance.repo.ts